<template>
  <transition>
    <div
      v-show="show"
      class="wrap"
    >
      <ShirtStack :class="shirtStackClasses" />
      <flickity
        :class="slidesClasses"
        :options="flickityOptions"
      >
        <Slide
          v-for="(shirt, index) in shirts"
          :key="index"
        >
          <component :is="shirt" />
        </Slide>
      </flickity>
    </div>
  </transition>
</template>

<script>
import Flickity from 'vue-flickity'
import { ShirtSmall, ShirtMedium, ShirtLarge, ShirtExtraLarge, ShirtStack } from './shirts'
import Slide from './Slide'

export default {
  name: 'Slides',
  data () {
    return {
      show: true,
      flickityOptions: {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        dragThreshold: 10
      },
      shirts: [ShirtSmall, ShirtMedium, ShirtLarge, ShirtExtraLarge]
    }
  },
  props: {
    pack: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$parent.$on('pack', () => {
      this.show = false
    })
  },
  components: {
    Flickity,
    Slide,
    ShirtStack
  },
  computed: {
    slidesClasses () {
      return {
        'intro-slides': true,
        'chosen': this.pack
      }
    },
    shirtStackClasses () {
      return {
        'shirt-stack': true,
        'pack': this.pack
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-leave-active {
  transition: all 1s cubic-bezier(.19,1,.22,1);
}

.v-leave-to {
  opacity: 0;
}

.intro-slides {
  position: relative;
  z-index: 2;
  opacity: 1;
  transform: translateY(0);
}

@keyframes pickThisOne {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }

  50% {
    opacity: 1;
    transform: scale(1.2) translateY(50px);
  }

  100% {
    opacity: 0;
    transform: scale(1.2) translateY(70px);
  }
}

.chosen {
  pointer-events: none;
  animation: pickThisOne 1s forwards;

  /deep/ .flickity-button {
    transition: all 500ms cubic-bezier(.19,1,.22,1);
    opacity: 0;
  }
}

.shirt-stack {
  position: absolute;
  z-index: 1;
  top: 73px;
  width: 240px;
  height: 287.24px;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  transition: opacity 1000ms cubic-bezier(.19,1,.22,1) 2000ms;
  will-change: opacity;

  @media (max-width: 479px) {
    top: 50px;
    width: 180px;
    height: 216.25px;
  }
}

.pack {
  opacity: 1;
}
</style>
<style lang="scss">
.intro-slides {
  .flickity-slider {
    transform: none !important;
  }
}
</style>
